import { API_BASE_URL, getBaseHeaders } from './api.config';
import { throwApiError } from './api.error';

export interface ContactRequest {
  name: string;
  email: string;
  subject: string;
  message: string;
  website: string;
}

export const sendContactRequest = async (request: ContactRequest): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/contact`, {
    method: 'POST',
    headers: {
      ...getBaseHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    await throwApiError(response);
  }
};
